import React from 'react';

import ContactsList from './ContactsList';

export const ContactsTab = () => {
	return <ContactsList />;
};
